import { render, staticRenderFns } from "./activitiesDetail2023bx.vue?vue&type=template&id=19f2a48a&scoped=true"
import script from "./activitiesDetail2023bx.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023bx.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023bx.vue?vue&type=style&index=0&id=19f2a48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f2a48a",
  null
  
)

export default component.exports